import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { details } from '../constants'

class DetailCard extends Component {
  render() {
    const { detail } = this.props
    const data = details[detail]
    return (
      <div className="flex-row w-33-ns mt4 mb0-ns">
        <div>
          <img src={data.image} width="36vh" height="36vh" alt="visualization" className="img center" />
        </div>
        <div className="justify-center default-color f3-ns f5 tc mt3">
          <FormattedMessage id={data.title} />
        </div>
        <div className="justify-center default-color text-light tc f6 f4-ns mt2 pa2-ns">
          <FormattedMessage id={data.description} />
        </div>
      </div>
    )
  }
}

DetailCard.propTypes = {
  detail: PropTypes.string.isRequired,
}

export default DetailCard



// WEBPACK FOOTER //
// ./src/components/DetailCard.js